import type { MessengerComposerDraft } from '@/api/client';
import { truncateMessengerThreadListPreview } from './messengerThreadListPreview';

const DRAFT_PREFIX = 'Черновик: ';

type DraftPreviewInput = Pick<
  MessengerComposerDraft,
  'text' | 'reply_to_message_id' | 'forward_message_ids'
>;

export function formatMessengerComposerDraftSubtitle(
  draft: DraftPreviewInput | null | undefined,
  maxLen = 72
): string | null {
  if (!draft) return null;

  const text = draft.text.trim();
  if (text) {
    return truncateMessengerThreadListPreview(`${DRAFT_PREFIX}${text}`, maxLen);
  }

  const attachmentLabels: string[] = [];
  if (draft.reply_to_message_id) attachmentLabels.push('ответ');
  if (draft.forward_message_ids.length > 0) attachmentLabels.push('пересылка');
  if (attachmentLabels.length === 0) return null;

  return truncateMessengerThreadListPreview(`${DRAFT_PREFIX}${attachmentLabels.join(', ')}`, maxLen);
}
